// import axios from '../../app-axios'

// const API_PATH = '/fast_sell/admins/brands'

const FastSellBrandsApi = {
  /**
   * Get FastSell Brands
   * @return {object} brand options for FastSelling Product
   */
  index: async () => {
    // const response = axios.get(API_PATH)

    // Mock Data
    const response = {
      data: {
        brands: [
          {
            id    : 363,
            value : 363,
            label : 'Balenciaga'
          },
          {
            id    : 565,
            value : 565,
            label : 'Bottega Veneta'
          },
          {
            id    : 717,
            value : 717,
            label : 'Celine'
          },
          {
            id    : 734,
            value : 734,
            label : 'Chanel'
          },
          {
            id    : 1050,
            value : 1050,
            label : 'Dior'
          },
          {
            id    : 1334,
            value : 1334,
            label : 'Fendi'
          },
          {
            id    : 1551,
            value : 1551,
            label : 'Goyard'
          },
          {
            id    : 1562,
            value : 1562,
            label : 'Gucci'
          },
          {
            id    : 1639,
            value : 1639,
            label : 'Hermes'
          },
          {
            id    : 2260,
            value : 2260,
            label : 'Loewe'
          },
          {
            id    : 2287,
            value : 2287,
            label : 'Louis Vuitton'
          },
          {
            id    : 3177,
            value : 3177,
            label : 'Prada'
          },
          {
            id    : 3461,
            value : 3461,
            label : 'Saint Laurent'
          }
        ]
      }
    }
    return response
  }
}

export default FastSellBrandsApi